import { formatDate } from '../utils/dateFormatter.js';
import { cutString } from '../utils/cutString.js';

/**
 * Защита от XSS атак 
 */
function escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

/**
 * Создает DOM элемент для строки сообщения
 * @param {Object} message - Объект сообщения
 * @returns {HTMLTableRowElement} Строка таблицы
 */
export function createMessageRow(message) {
    const row = document.createElement('tr');
    row.dataset.id = message.id;
    
    // Форматируем дату из timestamp
    const formattedDate = formatDate(message.received);
    // Сокращаем тему до 15 символов
    const cutedSubject = cutString(message.subject, 15);
    
    row.innerHTML = `
        <td>${escapeHtml(message.from)}</td>
        <td class="subject-truncated" title="${escapeHtml(message.subject)}">${escapeHtml(cutedSubject)}</td>
        <td>${formattedDate}</td>
    `;
    
    return row;
}

// сервер прислал: 
// {
//     id: "123",
//     from: "anna@mail.ru",
//     subject: "Очень важное сообщение",
//     received: 1744865237
// }
// Код превращает это в HTML:
// <tr data-id="123">
//     <td>anna@mail.ru</td>
//     <td class="subject-truncated" title="Очень важное сообщение">Очень важное...</td>
//     <td>15:47 17.04.2025</td>
// </tr>